import React from 'react';
import styled from 'styled-components';

const Card = () => {
  return (
    <CardContainer>
      <List>
        <ListItem className="iso-pro">
          <a href="https://www.facebook.com/share/yyErETtRu4wFuwmT/">
            <SvgFacebook className="icon" />
          </a>
          <Text>Facebook</Text>
        </ListItem>

        <ListItem className="iso-pro">
          <a href="https://www.youtube.com/@IBEXFILMZ-dr7fn">
            <SvgYouTube className="icon" />
          </a>
          <Text>YouTube</Text>
        </ListItem>

        <ListItem className="iso-pro">
          <a href="https://www.instagram.com/ibex_filmz?igsh=bGkxNzg0MmZveGk2">
            <SvgInstagram className="icon" />
          </a>
          <Text>Instagram</Text>
        </ListItem>
      </List>
    </CardContainer>
  );
};

// SVG for Facebook
const SvgFacebook = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 512"
    className="svg"
    fill="currentColor"
  >
    <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path>
  </svg>
);

// SVG for YouTube
const SvgYouTube = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    className="svg"
    fill="currentColor"
  >
    <path d="M549.655 124.083c-6.281-23.722-24.791-42.333-48.526-48.546C458.288 64 288 64 288 64s-170.288 0-213.13 11.538c-23.735 6.213-42.245 24.824-48.526 48.546C16 168.003 16 256.003 16 256.003s0 88.003 10.344 131.916c6.281 23.722 24.791 42.333 48.526 48.546C117.712 448 288 448 288 448s170.288 0 213.13-11.535c23.735-6.213 42.245-24.824 48.526-48.546C560 344.003 560 256.003 560 256.003s0-88-10.345-131.917zM232.74 337.37V174.63l142.78 81.37-142.78 81.37z"></path>
  </svg>
);

// SVG for Instagram
const SvgInstagram = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    className="svg"
    fill="currentColor"
  >
    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
  </svg>
);

const CardContainer = styled.div`
  max-width: fit-content;
  position: fixed;
  bottom: 10px;
  z-index: 10000;
  right: 0;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  gap: 0.8rem;
  backdrop-filter: blur(12px);
  box-shadow: inset 0 0 15px rgba(255, 255, 255, 0.192),
    inset 0 0 3px rgba(255, 255, 255, 0.274), 0 3px 3px rgba(0, 0, 0, 0.164);
  transition: 0.4s;
`;

const List = styled.ul`
  padding: 0.8rem;
  display: flex;
  list-style: none;
  gap: 0.8rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ListItem = styled.li`
  cursor: pointer;
  position: relative;

  .svg {
    transition: all 0.25s;
    padding: 0.8rem;
    height: 50px;
    width: 50px;
    border-radius: 100%;
    color: rgb(0, 157, 162);
    fill: currentColor;
    box-shadow: inset 0 0 15px rgba(255, 255, 255, 0.3),
      inset 0 0 3px rgba(255, 255, 255, 0.5), 0 3px 3px rgba(0, 0, 0, 0.164);
  }

  &:hover .svg {
    transform: translate(3px, -3px);
  }

  &:hover a > .svg {
    transform: translate(10px, -10px);
  }

  &:hover .text {
    opacity: 1;
    transform: translate(20px, -2px) skew(-5deg);
  }
`;

const Text = styled.div`
  opacity: 0;
  border-radius: 5px;
  font-weight: bold;
  padding: 4px;
  transition: all 0.25s;
  color: rgb(0, 157, 162);
  background-color: rgba(255, 255, 255, 0.3);
  position: absolute;
  z-index: 9999;
  box-shadow: -4px 0 1px rgba(153, 153, 153, 0.2),
    -8px 0 1px rgba(153, 153, 153, 0.2),
    inset 0 0 15px rgba(255, 255, 255, 0.3),
    inset 0 0 3px rgba(255, 255, 255, 0.5), 0 3px 3px rgba(0, 0, 0, 0.082);
`;


export default Card;
